import {formatMoney} from '../../utils/format-money';
import FormTextField from '../../components/form-textfield';

export const expenseLineAmountLabel = (data) => data.t.read('approval_requests_table.expense_line_amount');

export default function ReceiptTotals({data, receipts = [], totals = {}, canEditReceipt, onChange}) {
    const uniqueReceipts = [...new Map(receipts.map((receipt) => [receipt.id, receipt])).values()];
    if (!uniqueReceipts.length) return <span>{data.t.read('approval_requests_table.receipt_unavailable')}</span>;

    return uniqueReceipts.map((receipt) => (
        <div key={receipt.id}>
            {receipt.name && <div className="text-muted">{receipt.name}</div>}
            {onChange && canEditReceipt?.(receipt) ? <label className="d-block mb-0">
                <span className="sr-only">{data.t.read('approval_requests_table.receipt_total')}{receipt.name ? ` — ${receipt.name}` : ''}</span>
                <FormTextField
                format="money"
                value={String(totals[receipt.checksum] ?? receipt.total ?? '')}
                hideNA
                classes="approval-modal__editable-control"
                validateChange={value => onChange(receipt, value)}
                />
            </label> : <strong>{(totals[receipt.checksum] ?? receipt.total) == null
                ? data.t.read('approval_requests_table.receipt_unavailable')
                : formatMoney(totals[receipt.checksum] ?? receipt.total, receipt.currency || null)}</strong>}
        </div>
    ));
}
